import React, { memo } from 'react';
import { TouchableOpacity } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Text } from '@redlink/components/atoms';

export const StatusItem = memo(
  ({
    item,
    valueExtractor = (item) => item.value,
    onPress,
    isFocused = false,
    style,
  }) => {
    const { styles, colors } = useStyle();
    const value = valueExtractor(item);
    const backgroundColor = isFocused ? colors.blue1 : colors.white;
    const color = isFocused ? colors.white : colors.gray23;
    return (
      <TouchableOpacity
        {...{ onPress }}
        activeOpacity={0.6}
        style={[
          styles.container,
          style,
          styles.fixContainer,
          { backgroundColor },
        ]}
      >
        <Text style={[styles.text, { color }]}>{value}</Text>
      </TouchableOpacity>
    );
  }
);

const useStyle = createUseStyle(({ colors, shadow, size }) => ({
  container: {
    borderRadius: 24,
    alignItems: 'center',
    height: 48,
    minWidth: 100,
    ...shadow.card,
  },
  fixContainer: {
    flexDirection: 'row',
  },
  text: {
    flex: 1,
    paddingHorizontal: 16,
    fontSize: 16,
    lineHeight: 32,
    textAlign: 'center',
  },
}));
